import logo from '../logo.png';
import '../index.css';
import '../styles/modal.css';
import React, { useState, useEffect, useContext, useRef } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import authService from '../services/authService';

const RegistrationModal = ({ isOpen, onClose }) => {
    const { isDarkMode } = useContext(ThemeContext);
    const [email, setEmail] = useState('');
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [isButtonEnabled, setIsButtonEnabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const emailInputRef = useRef(null);

    useEffect(() => {
        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        setIsButtonEnabled(isValidEmail && termsAccepted);
    }, [email, termsAccepted]);

    useEffect(() => {
        if (isOpen && emailInputRef.current) {
            try {
                // Small timeout to ensure DOM is fully rendered
                setTimeout(() => {
                    if (emailInputRef.current) {
                        emailInputRef.current.focus();
                    }
                }, 100);
            } catch (error) {
                console.error("Error focusing input:", error);
            }
        }
    }, [isOpen]);

    const handleSendLink = async () => {
        if (!isButtonEnabled) return;
        
        console.log('Sending magic link...');
        setIsLoading(true);
        
        try {
            const result = await authService.sendMagicLink(email);
            
            if (result.status === 200) {
                alert("Magic link sent! Please check your email to log in.");
                onClose();
            } else {
                alert(`Error: ${result.message || 'Failed to send magic link'}`);
            }
        } catch (error) {
            console.error('Error sending magic link:', error);
            alert('Failed to send magic link. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;
  
    return (
        <div className="modal-overlay">
                <div className={`modal-content ${isDarkMode ? 'dark' : 'light'}`}>
                    <header className="App-header">
                        <div className="logo-container">
                            <img 
                                src={logo} 
                                alt="Svount Logo" 
                                style={{ 
                                    width: '50%', 
                                    height: 'auto', 
                                    marginBottom: '10px',
                                    filter: isDarkMode ? 'invert(1)' : 'none'
                                }} 
                            />
                        </div>
                        <input
                            ref={emailInputRef}
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={{ padding: '10px', margin: '10px 0', width: '90%' }}
                        />
                        <div style={{ margin: '10px 0' }}>
                            <input
                                type="checkbox"
                                id="terms"
                                checked={termsAccepted}
                                onChange={(e) => setTermsAccepted(e.target.checked)}
                            />
                            <label htmlFor="terms" style={{ fontSize: '10pt' }}>
                                I accept the <a 
                                    href="https://docs.google.com/document/d/1WesvoznwrfQSI7JHI8Lmon6NqJWFMziXmLUWe0vDqq0" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{ color: isDarkMode ? 'white' : 'blue' }}
                                >
                                    terms and conditions
                                </a>
                            </label>
                        </div>
                        <button 
                            onClick={handleSendLink} 
                            className={`modal-button ${isDarkMode ? 'dark' : 'light'}`}
                            disabled={!isButtonEnabled || isLoading}
                            style={{ marginTop: '10px' }}
                        >
                            {isLoading ? 'Sending...' : 'Sign Up'}
                        </button>
                        <button 
                            className={`close-button ${isDarkMode ? 'dark' : 'light'}`}
                            onClick={onClose}
                        >
                            ×
                        </button>
                    </header>
                    {isLoading && <div className="spinner-overlay">Loading...</div>}
                </div>
        </div>
    );
};
  
export default RegistrationModal; 